import ModalView from "app/views/Modal";

/*
* Base Controller class
* can also be used as a generic view controller
* when there is no controller logic needed, just
* view mount/unmount
*/
class Controller {

    constructor(appCtx, view) {
        this.appCtx = appCtx;
        this.view = view;
        this.init();
        // set when the controller is routed to
        // and unset once the controller is routed away from
        this.isActive = false;
    }

    init() {
        if(this.view && this.view.init) {
            this.view.init(this.appCtx);
        }
    }

    /**
    * This method should be called when the controller should become active
    */
    route(next) {
        this.isActive = true;
        if(this.view) {
            this.view.mount(this.appCtx);
        }
        if(next) { 
            next();
        }
    }

    /**
    * Call this method to deactivate the controller and unmount
    */
    exitRoute(next) {
        this.isActive = false;
        if(this.view) {
            this.view.unmount(this.appCtx);
        }
        next();
    }

    /**
    * Shows a generic error modal
    */
    showGenericError() {
        ModalView.createGenericErrorModal();
    }

}

export default Controller;
